import { patchClient } from "../../api/patchClient";
import type { WebchatHeading, WebchatHomePage } from "./model";
import {
  deploymentServiceGetDeploymentByInstalledAppUid,
  deploymentServiceUpsertDeployment,
  type deputy_v1_deploy_Integration,
  type deputy_v1_deploy_WebchatDeployment,
  type deputy_v1_deploy_Deployment,
  type deputy_v1_deploy_DeploymentConfig,
  deploymentServiceGetDeploymentByName,
} from "@deputy-ai/data-platform-api/v1/deploy";
import type { OverrideProperties } from "type-fest";

export type DeployWebChatDeployment = OverrideProperties<
  deputy_v1_deploy_WebchatDeployment,
  {
    pages?: {
      home: WebchatHomePage;
    };
    heading?: WebchatHeading;
  }
>;

export enum DeploymentIntegrationType {
  ACTIVE = "INTEGRATION_RESPONSE_TYPE_ACTIVELY",
  PASSIVE = "INTEGRATION_RESPONSE_TYPE_PASSIVE",
}

export type DeploymentConfig = OverrideProperties<
  deputy_v1_deploy_DeploymentConfig,
  {
    webchat: DeployWebChatDeployment;
  }
>;

export type Deployment = OverrideProperties<
  deputy_v1_deploy_Deployment,
  {
    config: DeploymentConfig;
  }
>;

export type DeployIntegration = deputy_v1_deploy_Integration;

export const getDeploymentApi = patchClient(
  deploymentServiceGetDeploymentByInstalledAppUid
);
export const upsertDeploymentApi = patchClient(
  deploymentServiceUpsertDeployment
);

export function toApiDeployment(
  deployment: Deployment
): deputy_v1_deploy_Deployment {
  return deployment as any;
}

export function toDeployment(
  apiDeployment: deputy_v1_deploy_Deployment
): Deployment {
  return apiDeployment as any;
}

export const getDeploymentsApi = patchClient(
  deploymentServiceGetDeploymentByName,
  {
    authed: false,
  }
);
